import { ConfigurationVariantDto2 } from '@/api-sdk';

export interface ReducedVariants {
  totalQuantity: number;
  colors: string[];
  sizes: string[];
  version?: string | null;
}

const addIfNotIncluded = (current: string[], code: string) => {
  return !current.includes(code) ? [...current, code] : current;
};

export const getReducedVariants = (variants: ConfigurationVariantDto2[]) => {
  return variants.reduce(
    (reduced: ReducedVariants, variant): ReducedVariants => {
      const { color, size, quantity, version } = variant;

      return {
        totalQuantity: reduced.totalQuantity + quantity,
        colors: color
          ? addIfNotIncluded(reduced.colors, color.code)
          : reduced.colors,
        sizes: size
          ? addIfNotIncluded(reduced.sizes, size.code)
          : reduced.sizes,
        version: version ? version.name : version,
      };
    },
    {
      totalQuantity: 0,
      colors: [],
      sizes: [],
      version: '',
    },
  );
};
